module.exports = __webpack_public_path__ + "static/media/run_4.d7a2b851.png";